import { RouteItem } from '@eastcoal/router/types/route'

import {
  APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH,
  APPLY_ANNOUNCEMENT_LIST_PAGE_PATH
} from './constants/path'

export const applyAnnouncementRoute: RouteItem = {
  title: '竞价预告',
  hideInMenu: true,
  children: [
    {
      title: '列表',
      path: APPLY_ANNOUNCEMENT_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '详情',
      path: APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH,
      Component: () => import('./Detail/index')
    }
  ]
}
